<app-modal class="issue-create-modal">
    <ng-container modal-header>
        <h5 class="modal-title" *ngIf="!isViewMode; else viewTitle">{{
                'admin.issues.modal.title.add'
                    | translate
            }}</h5>
        <ng-template #viewTitle>
            <h5 class="modal-title">{{ 'admin.issues.modal.title.view' | translate }}</h5>
        </ng-template>
    </ng-container>
    <ng-container modal-body>
        <form [formGroup]="issueForm">
            <div class="row">
                <div class="col s12">
                    <app-input-switch formControlName="isReplacementOrdered"
                                      [formControl]="issueForm.controls['isReplacementOrdered']"
                                      [disabled]="isViewMode"
                                      topLabel="{{'admin.issues.modal.isReplacementOrdered.label' | translate }}">
                    </app-input-switch>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    <div class="row">
                        <app-display-label
                            [inlineLabel]="true"
                            label="{{'admin.issues.modal.status.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.status">
                        </app-display-label>
                    </div>
                    <div class="row">
                        <app-display-label
                            label="{{'admin.issues.modal.createdAt.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.createdAt"
                            [inlineLabel]="true">
                        </app-display-label>
                    </div>
                    <div class="row">
                        <app-display-label
                            label="{{'admin.issues.modal.createdBy.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.user?.fullName"
                            [inlineLabel]="true">
                        </app-display-label>
                    </div>
                    <div class="row">
                        <app-display-label
                            label="{{'admin.issues.modal.line.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.line?.name"
                            [valueStyle]=""
                            [inlineLabel]="true">
                        </app-display-label>
                    </div>
                </div>
                <div class="col s6">
                    <div class="row">
                        <app-display-label
                            label="{{'admin.issues.modal.reason.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.reason?.name">
                        </app-display-label>
                    </div>
                    <div class="row">
                        <app-textbox
                            label="{{'admin.issues.modal.description.label' | translate}}"
                            [labelClass]="'compact'"
                            [value]="issue?.description">
                        </app-textbox>
                    </div>
                </div>
                <div class="row" *ngIf="selectedTool">
                    <div class="col s12" id="selectedTool">
                        <app-display-label
                            label="{{'admin.issues.modal.selectedTool' | translate}}"
                            [labelClass]="'compact'"
                            [value]="selectedTool.identifierName"
                            [valueStyle]=""
                            [inlineLabel]="true">
                        </app-display-label>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12">
                        <app-tool-scan-tree
                            labelText="{{'admin.issues.modal.toolsListTitle'| translate}}"
                            [items]="issue.tools">
                        </app-tool-scan-tree>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
    <div class="modal-footer" modal-footer>
        <app-button *ngIf="hasCancel"
                    [disabled]="isLoading"
                    type="simple"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="hasApprove"
                        [disabled]="isLoading"
                        type="primary"
                        (click)="emitPromote(false)">
                {{ 'generic.buttons.promoteToTicket'| translate }}
            </app-button>
            <app-button *ngIf="hasApprove && multipleTools"
                        [disabled]="isLoading"
                        type="primary"
                        (click)="emitPromote()">
                <span>{{ 'generic.buttons.promoteToTicketAllTools'| translate }}</span>
            </app-button>
            <app-button *ngIf="hasReject"
                        [disabled]="isLoading"
                        type="danger"
                        (click)="emitReject(false)">
                {{ 'generic.buttons.reject'| translate }}
            </app-button>
            <app-button *ngIf="hasReject && multipleTools"
                        [disabled]="isLoading"
                        type="danger"
                        (click)="emitReject()">
                <span>{{ 'generic.buttons.rejectIssueForAllTools'| translate }}</span>
            </app-button>
        </div>
    </div>
</app-modal>
